// router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'
import { Message, MessageBox } from 'element-ui'  // 如果有使用 Element UI
import ajaxapi from '../api/api'
Vue.use(VueRouter)

// 定义路由
const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { 
      title: '登录', 
      icon: 'el-icon-user',
      noAuth: true  // 标记为不需要认证的页面
    }
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/common/errorPage/404.vue'),
    meta: { noAuth: true }
  },
  {
    path: '/401',
    name: 'Unauthorized',
    component: () => import('@/views/common/errorPage/401.vue'),
    meta: { noAuth: true }
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: 'promoPage',
        name: 'advertisement',
        component: () => import('@/views/advertisement/index.vue'),
        meta: { 
          title: '定制方案', 
          requiresAuth: false  // 需要登录认证
        },
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { 
          title: '项目检索', 
          icon: 'el-icon-search',
          requiresAuth: true  // 需要登录认证
        },
      },
      {
        path: 'contact',
        name: 'contact',
        component: () => import('@/views/contact/index.vue'),
        meta: { 
          title: '联系人', 
          icon: 'el-icon-user',
          requiresAuth: true  // 需要登录认证
        },
      },
      {
        path: 'constructionIndustry',
        name: 'constructionIndustry',
        component: () => import('@/views/constructionIndustry/index.vue'),
        meta: { 
          title: '建筑行业数据', 
          icon: 'el-icon-coin',
          requiresAuth: true  // 需要登录认证
        },
      },
      {
        path: 'enterpriseDetail',
        name: 'enterpriseDetail',
        component: () => import('@/views/commonDetail/enterpriseDetail.vue'),
        meta: { 
          title: '建设单位详情', 
          icon: 'el-icon-coin',
          requiresAuth: true  // 需要登录认证
        },
      },
      {
        path: 'enterpriseDetail2',
        name: 'enterpriseDetail2',
        component: () => import('@/views/commonDetail/enterpriseDetail2.vue'),
        meta: { 
          title: '建设单位详情测试', 
          icon: 'el-icon-coin',
          requiresAuth: true  // 需要登录认证
        },
      },
      
      {
        path: 'constructionProject',
        name: 'constructionProject',
        component: () => import('@/views/constructionProject/index.vue'),
        meta: { 
          title: '建设单位', 
          icon: 'el-icon-coin',
          requiresAuth: true  // 需要登录认证
        },
      },
      {
        path: 'constructionProject/detail',
        name: 'constructionProjectDetail',
        component: () => import('@/views/constructionProject/detail.vue'),
        meta: { 
          title: '建设单位详情', 
          icon: 'el-icon-coin',
          requiresAuth: true  // 需要登录认证
        },
      },
      {
        path: '/contact/detail',
        name: 'contactDetail',
        component: () => import('@/views/contact/detail.vue'),
        meta: { 
          title: '联系人详情', 
          icon: 'el-icon-user',
          requiresAuth: true  // 需要登录认证
        },
      },
      {
        path: '/ExamineNotice/detail',
        name: 'ExamineNotice',
        component: () => import('@/views/dashboard/ExamineNotice/detail.vue'),
        meta: { 
          title: '审批项目详情', 
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: '/ApprovalNotice/detail',
        name: 'ApprovalNotice',
        component: () => import('@/views/dashboard/ApprovalNotice/detail.vue'),
        meta: { 
          title: '项目核准详情', 
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: '/RecordPublic/detail',
        name: 'RecordPublic',
        component: () => import('@/views/dashboard/RecordPublic/detail.vue'),
        meta: { 
          title: '项目备案详情', 
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: '/EnergyNotice/detail',
        name: 'EnergyNotice',
        component: () => import('@/views/dashboard/EnergyNotice/detail.vue'),
        meta: { 
          title: '节能审查详情', 
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: '/LandPreapproval/detail',
        name: 'LandPreapproval',
        component: () => import('@/views/dashboard/LandPreapproval/detail.vue'),
        meta: { 
          title: '用地预审详情', 
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: '/LandPermit/detail',
        name: 'LandPermit',
        component: () => import('@/views/dashboard/LandPermit/detail.vue'),
        meta: { 
          title: '用地规划许可详情', 
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: '/ConstructionPermit/detail',
        name: 'LandPermit',
        component: () => import('@/views/dashboard/ConstructionPermit/detail.vue'),
        meta: { 
          title: '工程规划许可', 
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: '/EiaReport/detail',
        name: 'EiaReport',
        component: () => import('@/views/dashboard/EiaReport/detail.vue'),
        meta: { 
          title: '环境评价', 
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: '/landSearch/detail',
        name: 'LandPermit',
        component: () => import('@/views/dashboard/landSearch/detail.vue'),
        meta: { 
          title: '项目拿地', 
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: '/buildPermit/detail',
        name: 'buildPermit',
        component: () => import('@/views/dashboard/buildPermit/detail.vue'),
        meta: { 
          title: '施工许可', 
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: '/tenderingBidding/detail',
        name: 'tenderingBidding',
        component: () => import('@/views/dashboard/tenderingBidding/detail.vue'),
        meta: { 
          title: '招投标', 
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: 'chain',
        name: 'chain',
        component: () => import('@/views/chain/index.vue'),
        meta: { 
          title: '产业链', 
          icon: 'el-icon-location',
          requiresAuth: true
        }
      },
      {
        path: 'monitoring',
        name: 'Monitoring',
        component: () => import('@/views/monitoring/index.vue'),
        meta: { 
          title: '重点监测', 
          icon: 'el-icon-location',
          requiresAuth: true
        }
      },
      {
        path: 'statistics',
        name: 'Statistics',
        component: () => import('@/views/statistics/index.vue'),
        meta: { 
          title: '统计分析', 
          icon: 'el-icon-data-analysis',
          requiresAuth: true
        }
      },
      {
        path: 'totalEnterprises',
        name: 'totalEnterprises',
        component: () => import('@/views/enterprise/totalEnterprises.vue'),
        meta: { 
          title: '全部企业库', 
          icon: 'el-icon-office-building',
          requiresAuth: true
        }
      },
      {
        path: 'enterpriseList',
        name: 'enterpriseList',
        component: () => import('@/views/enterprise/enterpriseList.vue'),
        meta: { 
          title: '企业库', 
          icon: 'el-icon-office-building',
          requiresAuth: true
        }
      },
      {
        path: 'enterpriseTag',
        name: 'enterpriseTag',
        component: () => import('@/views/enterprise/tagSearch.vue'),
        meta: { 
          title: '标签概念搜索', 
          icon: 'el-icon-office-building',
          requiresAuth: true
        }
      },
      {
        path: 'totalSearch',
        name: 'totalSearch',
        component: () => import('@/views/enterprise/totalSearch.vue'),
        meta: { 
          title: '企业搜索', 
          icon: 'el-icon-office-building',
          requiresAuth: true
        }
      },
      
      {
        path: 'report',
        name: 'report',
        component: () => import('@/views/report/index.vue'),
        meta: { 
          title: '研究报告', 
          icon: 'el-icon-document',
          requiresAuth: true
        }
      },
      {
        path: 'calculator',
        name: 'Calculator',
        component: () => import('@/views/calculator/index.vue'),
        meta: { 
          title: '关系计算器', 
          icon: 'el-icon-s-grid',
          requiresAuth: true
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',  // 使用 hash 模式
  // base: '/',
  routes
})

// 白名单路由（不需要登录就可以访问的页面）
const whiteList = ['/login', '/404', '/401']

// 检查登录状态的函数
const checkLogin = () => {
  try {
    const userData = localStorage.getItem('userData') || sessionStorage.getItem('userData')
    if (!userData) return false
    
    const parsedData = JSON.parse(userData)
    return !!(parsedData && parsedData.token)
  } catch (error) {
    console.error('解析 localStorage 中的 userData 失败:', error)
    return false
  }
}

// 路由守卫
router.beforeEach((to, from, next) => {
  console.log('ajaxapi', ajaxapi.getWebsiteType());
  console.log('路由跳转:', from.path, '->', to.path)
  
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title + ' - 智瞰平台'
  }
  
  // 判断目标路由是否在白名单中
  if (whiteList.includes(to.path)) {
    return next()
  }
  
  // 检查是否已登录
  const isAuthenticated = checkLogin()
  
  if (!isAuthenticated) {
    console.log('未登录，跳转到登录页')
    
    // 存储当前路由，登录后可以跳转回来
    if (to.path !== '/login') {
      localStorage.setItem('redirectPath', to.fullPath)
    }
    
    // 如果有 Element UI 的 Message 组件
    if (Message) {
      Message.warning('请先登录！')
    }
    
    return next({
      path: '/login',
      query: { redirect: to.fullPath }  // 可以传递重定向路径
    })
  }
  
  // 已登录状态，但访问的是登录页，则重定向到首页
  if (to.path === '/login') {
    return next({ path: '/' })
  }
  
  // 正常放行
  next()
})

// 路由后置钩子
router.afterEach((to, from) => {
  // 可以在这里添加页面访问统计等
})

export default router